import Component from '../core/Component'
import Scroll from '../services/Scroll'
import {CMS} from '../core/config'
import EventBus from '../core/EventBus'
import {EVENTS} from '../core/Events'

export const STATES = {
    SLIDER_ACTIVE: 'is-slider-active',
    IS_PREV_VISIBLE: 'is-prev-visible',
    IS_NEXT_VISIBLE: 'is-next-visible'
}

export const EMITS = {
    SELECTED: 'selected'
}

export default class LocationSlider extends Component {
    constructor(element, options = {}) {
        super(element, options)

        this.ref = {
            prevs: [],
            nexts: [],
            items: [],
            slider: null
        }

        this.index = null
    }

    prepare() {
        if (CMS) {
            return
        }

        this.ref.prevs.forEach(prev => prev.addEventListener('click', this.handlePrevClick))
        this.ref.nexts.forEach(prev => prev.addEventListener('click', this.handleNextClick))

        Scroll.on('resize', this.handleResize)
        EventBus.on(EVENTS.MODAL_OPEN, this.handleModalOpen)

        this.element.classList.add('is-ready')
        this.checkPrevNext()
    }

    destroy() {
        Scroll.off('resize', this.handleResize)
        EventBus.off(EVENTS.MODAL_OPEN, this.handleModalOpen)
    }

    getItems() {
        return this.ref.items
    }

    handlePrevClick = () => {
        this.selectPrev()
    }

    handleNextClick = () => {
        this.selectNext()
    }

    handleResize  = () =>{
        this.resize()
    }

    handleModalOpen = (info) => {
        if (!info?.modal?.element?.contains(this.element)) {
            return
        }
        const {locationId} = info.data
        if (!locationId) {
            return
        }

        const index = this.ref.items.findIndex(item => item.getAttribute('data-location-id') === locationId)
        if (index < 0) {
            return
        }

        this.select(index)
    }

    resize() {
        const item = this.ref.items[this.index]
        // if (item) {
        //     this.ref.slider.style.height = `${item.getBoundingClientRect().height}px`
        // }
    }

    select(index) {
        if (this.index === index) {
            return
        }

        this.element.classList.toggle('is-backwards', this.index > index)

        this.index = index

        this.ref.items.forEach((item,_index) => {
            const isActive = index === _index
            item.classList.toggle('is-active', isActive)
        })


        this.checkPrevNext()
        this.resize()
    }

    selectPrev() {
        let index = this.index - 1
        if (index < 0) {
            index = 0
        }
        this.select(index)
    }

    selectNext() {
        let index = this.index + 1
        if (index >= this.ref.items.length) {
            index = this.ref.items.length-1
        }
        this.select(index)
    }

    checkPrevNext() {
        this.element.classList.toggle(STATES.IS_NEXT_VISIBLE, this.index < this.ref.items.length - 1)
        this.element.classList.toggle(STATES.IS_PREV_VISIBLE, this.index > 0)
    }
}
